import React from 'react';
import './PopupChecklist.css';

const PopupChecklist = ({
  options = [],
  selectedValues = [],
  onChange = () => {},
  onClose = () => {}
}) => {
  const handleToggle = (id) => {
    if (!id) return;
    const updated = selectedValues.includes(id)
      ? selectedValues.filter((val) => val !== id)
      : [...selectedValues, id];
    onChange(updated);
  };

  return (
    <div className="popup-checklist">
      {Array.isArray(options) && options.length > 0 ? (
        options.map((opt, index) => {
          const id = opt?.id;
          const label = opt?.label ?? 'Unnamed';

          if (!id) return null; // skip malformed items without id

          return (
            <label key={id || index} style={{ display: 'block' }}>
              <input
                type="checkbox"
                checked={selectedValues?.includes(id)}
                onChange={() => handleToggle(id)}
              />
              {label}
            </label>
          );
        })
      ) : (
        <p style={{ fontStyle: 'italic', color: '#888' }}>No options available</p>
      )}

      <div className="popup-checklist-save-icon" onClick={onClose} title="Close">
        <i className="fas fa-check-circle"></i>
      </div>
    </div>
  );
};

export default PopupChecklist;
